import React, { useEffect, useState, useRef, useCallback } from 'react';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

const Toast = ({ message, type = 'info', duration = 3000, onClose, id }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const toastRef = useRef(null);

  const handleClose = useCallback(() => {
    if (isClosing) return;
    setIsClosing(true);
    setIsVisible(false);
    setTimeout(() => {
      if (onClose) onClose(id);
    }, 200);
  }, [isClosing, onClose, id]);

  useEffect(() => {
    queueMicrotask(() => setIsVisible(true));
    const timer = setTimeout(() => {
      handleClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, handleClose]);

  const icons = {
    success: CheckCircle,
    error: XCircle,
    warning: AlertCircle,
    info: AlertCircle,
  };

  const colors = {
    success: '#10B981',
    error: '#EF4444',
    warning: '#F59E0B',
    info: '#3B82F6',
  };

  const Icon = icons[type] || icons.info;

  return (
    <div
      ref={toastRef}
      style={{
        background: 'rgba(0, 0, 0, 0.95)',
        border: `1px solid ${colors[type]}`,
        borderRadius: '8px',
        padding: '12px 16px',
        marginBottom: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        minWidth: '300px',
        maxWidth: '400px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateX(0)' : 'translateX(-300px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
      }}
    >
      <Icon size={20} style={{ color: colors[type], flexShrink: 0 }} />
      <div style={{ flex: 1, color: '#fff', fontSize: '14px' }}>{message}</div>
      <button
        onClick={handleClose}
        style={{
          background: 'none',
          border: 'none',
          color: '#fff',
          cursor: 'pointer',
          padding: '4px',
          display: 'flex',
          alignItems: 'center',
          opacity: 0.6,
        }}
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default Toast;
